export default {"src":"/_next/static/media/sort_upward.a545ea14.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};